import {
  AlertTriangle,
  BadgeDollarSign,
  PackageCheck,
  PackageSearch,
  RefreshCw,
} from "lucide-react";
import { UserKpiCard } from "@/pages/users/components/UserKpiCard";
import type { StockMetrics } from "../stock-calculations";
import { formatMoney } from "../stock-formatters";

interface StockKpiGridProps {
  articlesCount: number;
  loadingMovements: boolean;
  metrics: StockMetrics;
}

export function StockKpiGrid({ articlesCount, loadingMovements, metrics }: StockKpiGridProps) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
      <UserKpiCard
        label="Articles actifs"
        value={String(metrics.activeCount)}
        detail={`${articlesCount} article${articlesCount > 1 ? "s" : ""} affiché${articlesCount > 1 ? "s" : ""}`}
        icon={PackageCheck}
        tone="gold"
      />
      <UserKpiCard
        label="Unités en stock"
        value={String(metrics.stockUnits)}
        detail="Quantité disponible"
        icon={PackageSearch}
        tone="success"
      />
      <UserKpiCard
        label="Valeur stock"
        value={formatMoney(metrics.stockValue)}
        detail="Au coût fournisseur"
        icon={BadgeDollarSign}
        tone="success"
      />
      <UserKpiCard
        label="Gain potentiel"
        value={formatMoney(metrics.potentialGain)}
        detail="Marge vente - fournisseur"
        icon={BadgeDollarSign}
        tone="gold"
      />
      <UserKpiCard
        label="Urgences"
        value={String(metrics.lowStockCount)}
        detail={`${metrics.outOfStockCount} rupture${metrics.outOfStockCount > 1 ? "s" : ""}`}
        icon={AlertTriangle}
        tone={metrics.lowStockCount > 0 ? "danger" : "neutral"}
      />
      <UserKpiCard
        label="Mouvements"
        value={loadingMovements ? "..." : String(metrics.negativeOverrides)}
        detail={`${metrics.negativeOverrides} sortie${metrics.negativeOverrides > 1 ? "s" : ""} forcée${metrics.negativeOverrides > 1 ? "s" : ""}`}
        icon={RefreshCw}
        tone={metrics.negativeOverrides > 0 ? "danger" : "neutral"}
      />
    </div>
  );
}
